export default __webpack_public_path__ + "static/media/topic-arrow-icon.dbb87694.svg";